import React from 'react';
import {View} from 'react-native';

import {ProfileActiveAttribute} from '/component/base/ProfileActiveAttribute';
import Text from '/component/base/Text';
import {ProfilePage} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {getAppVersion} from '/util/device-info.util';
import {openURL} from '/util/linking.util';

import {styles} from './AppInfoSection.style';

type AppInfoSectionProps = {
  // eslint-disable-next-line react/require-default-props
  showVersion?: boolean;
};

export const AppInfoSection = ({showVersion = true}: AppInfoSectionProps) => {
  const {tt} = useTranslation('screen.profile.appInfoSection');
  return (
    <View style={styles.base}>
      <ProfileActiveAttribute
        testID={ProfilePage.profilePrivacyPolicy}
        label={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={{color: '#333333'}}>
            {tt('privacyPolicy', 'Privacy Policy')}
          </Text>
        }
        onPress={() =>
          openURL('url', 'https://www.optavia.com/us/en/privacy-policy')
        }
        accessible={true}
        accessibilityRole="link"
        accessibilityLabel="Privacy Policy"
        // Ensure required props are provided and avoid light/low-contrast defaults
        style={{}}
        iconName=""
        isLastElement={false}
        useCompetency={false}
      />
      <ProfileActiveAttribute
        testID={ProfilePage.profileTermsConditions}
        label={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={{color: '#333333'}}>
            {tt('termsConditions', 'Terms & Conditions')}
          </Text>
        }
        onPress={() =>
          openURL('url', 'https://www.optavia.com/us/en/terms-conditions')
        }
        accessible={true}
        accessibilityRole="link"
        accessibilityLabel="Terms and Conditions"
        style={{}}
        iconName=""
        isLastElement={false}
        useCompetency={false}
      />
      {showVersion && (
        <View
          style={styles.versionContainer}
          accessible={true}
          accessibilityRole="text">
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('appVersion', 'App version')}
          </Text>
          <Text
            variant={'heading'}
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={ProfilePage.profileAppVersion}>
            {getAppVersion()}
          </Text>
        </View>
      )}
    </View>
  );
};
